/**
 * GCP opens in USD instead of inheriting a currency selected on another
 * provider. Once the user selects a currency on the GCP page, `currentValue`
 * takes precedence so the selector continues to work normally.
 */
export default function resolveCurrency(
    pathname: string,
    currentValue: string | undefined,
    lastCurrency: string | null,
) {
    const isGcpPath = /(^|\/)gcp(\/|$)/.test(pathname);
    return currentValue || (isGcpPath ? "USD" : lastCurrency) || "USD";
}
